module.exports = __webpack_public_path__ + "fonts/ComicNeueSansID.7500b056.ttf";